import iconA from '@eeacms/volto-columns-block/ColumnsBlock/icons/two-half-columns.svg';
import iconB from '@eeacms/volto-columns-block/ColumnsBlock/icons/one-third-left.svg';
import iconC from '@eeacms/volto-columns-block/ColumnsBlock/icons/one-third-right.svg';
import iconD from '@eeacms/volto-columns-block/ColumnsBlock/icons/three-third-columns.svg';
import iconE from '@eeacms/volto-columns-block/ColumnsBlock/icons/three-columns.svg';
import iconF from '@eeacms/volto-columns-block/ColumnsBlock/icons/four-quarter-columns.svg';
import iconH from '@eeacms/volto-columns-block/ColumnsBlock/icons/three-columns-hqq.svg';
import iconI from '@eeacms/volto-columns-block/ColumnsBlock/icons/three-columns-qqh.svg';

export const gridSizes = {
  full: {
    mobile: 12,
    tablet: 12,
    computer: 12,
  },
  halfWidth: {
    mobile: 12,
    tablet: 6,
    computer: 6,
  },
  twoThirds: {
    mobile: 12,
    tablet: 8,
    computer: 8,
  },
  oneThird: {
    mobile: 12,
    tablet: 4,
    computer: 4,
  },
  halfWidthBig: {
    mobile: 12,
    tablet: 8,
    computer: 6,
  },
  oneThirdSmall: {
    mobile: 12,
    tablet: 2,
    computer: 3,
  },
  oneQuarter: {
    mobile: 12,
    tablet: 6,
    computer: 3,
  },
  oneFifth: {
    mobile: 12,
    tablet: 2,
    computer: 3,
  },
  fourFifths: {
    mobile: 12,
    tablet: 10,
    computer: 9,
  },
  twoFifths: {
    mobile: 12,
    tablet: 10,
    computer: 5,
  },
  threeFifths: {
    mobile: 12,
    tablet: 10,
    computer: 7,
  },
};

export const variants = [
  {
    icon: iconA,
    defaultData: {
      gridSize: 12,
      gridCols: [1, 1],
    },
    common: true,
    title: '1:1',
  },
  {
    icon: iconB,
    defaultData: {
      gridSize: 12,
      gridCols: [1, 2],
    },
    common: true,
    title: '1:2',
  },
  {
    icon: iconC,
    defaultData: {
      gridSize: 12,
      gridCols: [2, 1],
    },
    common: true,
    title: '2:1',
  },
  {
    icon: iconB,
    defaultData: {
      gridSize: 12,
      gridCols: [1, 3],
    },
    common: true,
    title: '1:3',
  },
  {
    icon: iconC,
    defaultData: {
      gridSize: 12,
      gridCols: [3, 1],
    },
    common: true,
    title: '3:1',
  },
  {
    icon: iconD,
    defaultData: {
      gridSize: 12,
      gridCols: [1, 1, 1],
    },
    common: true,
    title: '1:1:1',
  },
  {
    icon: iconI,
    defaultData: {
      gridSize: 12,
      gridCols: [1, 1, 2],
    },
    common: true,
    title: '1:1:2',
  },
  {
    icon: iconE,
    defaultData: {
      gridSize: 12,
      gridCols: [1, 2, 1],
    },
    common: true,
    title: '1:2:1',
  },
  {
    icon: iconH,
    defaultData: {
      gridSize: 12,
      gridCols: [2, 1, 1],
    },
    common: true,
    title: '2:1:1',
  },
  {
    icon: iconF,
    defaultData: {
      gridSize: 12,
      gridCols: [1, 1, 1, 1],
    },
    common: true,
    title: '1:1:1:1',
  },
];
